import { environment } from '@environments/environment';
import { createApiConfiguration } from '@fagforbundet/ngx-components';
import { CmsApiEndpoints } from '@config/apis/cms/cms-api-endpoints';

export const cmsApiConfig = createApiConfiguration<typeof CmsApiEndpoints>({
  baseUrl: environment.apis.cms.baseUrl,
  endpoints: CmsApiEndpoints,
});
